var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "send"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7072 2.29289C21.9813 2.56705 22.0723 2.97497 21.9406 3.33964L15.4406 21.3396C15.4312 21.3657 15.4207 21.3914 15.4092 21.4166C15.2855 21.6864 15.087 21.9151 14.8372 22.0754C14.5874 22.2357 14.2969 22.3209 14.0001 22.3209C13.7033 22.3209 13.4127 22.2357 13.1629 22.0754C12.9191 21.9189 12.7241 21.6973 12.6 21.4359L9.25471 14.7454L2.56418 11.4001C2.30276 11.2759 2.08118 11.081 1.92471 10.8371C1.76441 10.5874 1.6792 10.2968 1.6792 10C1.6792 9.7032 1.76441 9.41264 1.92471 9.16285C2.08501 8.91307 2.31366 8.71455 2.58347 8.59091C2.60868 8.57936 2.63435 8.56886 2.66043 8.55944L20.6604 2.05944C21.0251 1.92776 21.433 2.01873 21.7072 2.29289ZM11.2168 14.1975L13.9322 19.6282L18.5366 6.87769L11.2168 14.1975ZM17.1224 5.46348L4.37183 10.0678L9.80261 12.7832L17.1224 5.46348Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.e4c54cea176f0ed58f02faf89d1bd02e.svg";
export { ForwardRef as ReactComponent };